import { ArrowLeft } from 'lucide-react';
import { Link } from 'wouter';
import { Button } from '../components/ui/button';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="text-8xl font-bold text-brand font-mono mb-4">404</div>
        <h1 className="text-2xl font-bold text-foreground mb-2" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
          页面未找到
        </h1>
        <p className="text-muted-foreground mb-8">您访问的页面不存在或已被移除</p>
        <Button className="btn-brand gap-2" asChild>
          <Link href="/">
            <ArrowLeft className="h-4 w-4" />
            返回首页
          </Link>
        </Button>
      </div>
    </div>
  );
}
